"use strict";

exports.__esModule = true;
var _CalendarScreen = require("./CalendarScreen");
Object.keys(_CalendarScreen).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _CalendarScreen[key]) return;
  exports[key] = _CalendarScreen[key];
});